import React from 'react'

import { Column, Container, Row } from '@/components/base/gridview'
import Image from '@/components/base/image/Image'

import { OperationRepairProps } from './type'

const OperationRepair: React.FunctionComponent<OperationRepairProps> = ({
  title,
  children,
  image,
}) => {
  return (
    <div className="operation-repair">
      <Container size="extended">
        <Row>
          <Column
            xs={{ size: 12 }}
            sm={{ size: 12 }}
            md={{ size: 12 }}
            lg={{ size: 12 }}
            xl={{ size: 12 }}
          >
            <div className="operation-repair-title">{title}</div>
          </Column>
        </Row>
        <Row className="repairItemColumn">
          {children}
          <Image className="absolute-image" {...image} alt={title} />
        </Row>
      </Container>
    </div>
  )
}

export default OperationRepair
